export const blockIconsCommunicationTextsms = (
	<span className='material-symbols-outlined'>textsms</span>
);
